import {useEffect} from "react";

import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer'
import DynamSoftScanComponent from "./ScanComponent/DynamSoftScanComponent";

interface BarCodeScannerState {
    scanResult: string;
    lastScanResult: string;
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    setScanResult: (scanResult: string) => Promise<void>;
}

export const useBarCodeScanner = create<BarCodeScannerState>()(
    immer((set, get) => ({
        // 默认状态
        scanResult: '',
        lastScanResult: '',
        isVisible: true,
        setIsVisible: (isVisible: boolean) => {
            set({ isVisible });
        },
        setScanResult: async (scanResult: string) => {
            const currentState = get();
            // 如果当前扫码结果与上一次相同，不做处理
            if (currentState.lastScanResult === scanResult) {
                return;
            }

            // 设置新的扫码结果和上次结果
            set({
                scanResult,
                lastScanResult: scanResult
            });

            // 只有当扫码结果非空时，才在3秒后重置
            if (scanResult.trim() !== '') {
                await new Promise(resolve => setTimeout(resolve, 3000));
                set(state => {
                    // 只有当当前结果与要重置的结果相同时才重置
                    if (state.scanResult === scanResult) {
                        return { scanResult: '' };
                    }
                    return state;
                });
            }
        },
    }))
);

export const useBarCodeScannerResult = () => {
    return useBarCodeScanner(state => state.scanResult);
}

interface BarCodeScannerProps {
    showManualInputIcon?: boolean;
}

export const BarCodeScanner = ({ showManualInputIcon = true }: BarCodeScannerProps) => {
    const setScanResult = useBarCodeScanner(state => state.setScanResult);
    const isVisible = useBarCodeScanner(state => state.isVisible);


    const handleScanSuccess = (scanResult: string) => {
        console.log('BarCodeScanner: scanResult', scanResult);
        setScanResult(scanResult);
    }

    useEffect(() => {
        const resetScanResult = async () => {
            await setScanResult("");
        }
        resetScanResult();
    }, [setScanResult]);

    return (
        <div className="relative">
            {isVisible && (
                <div className="w-full relative z-10" style={{ height: '40vh' }}>
                    <DynamSoftScanComponent 
                        onScanSuccess={handleScanSuccess}
                        showManualInputIcon={showManualInputIcon}
                    />
                </div>
            )}
        </div>
    );
};